module.exports = __webpack_public_path__ + "img/9788988996904.fd8831d9.jpg";